import axios from "../../util/axios";
import { ActionType } from "../actionTypes/index";
import type { Dispatch } from "redux";
import config from "../../config/config";

export function getUsers(params: any) {
  return async function (dispatch: Dispatch) {
    // Destructure signal and other known params
    const { signal, page, take, search, sortField, sortOrder, ...otherParams } =
      params;

    const apiParams: any = { page, take, search, ...otherParams };

    if (sortField) {
      apiParams.sortField = sortField;
      apiParams.sortOrder = sortOrder;
    }

    try {
      await axios
        .get(`${config.defaults.api_url}/user/all`, {
          params: apiParams,
          signal: signal,
        })
        .then((res: any) => {
          dispatch({
            type: ActionType.GET_ALL_USERS,
            payload: res,
          });
        });
    } catch (error) {
      console.error(error);
      dispatch({
        type: ActionType.GET_ALL_USERS_FAILED,
        payload: {
          message: "Unable to get users",
        },
      });
    }
  };
}
